import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
@Component({
    selector: 'app-escalation-nav',
    templateUrl: './escalation-nav.component.html',
    styleUrls: ['./escalation-nav.component.css'],
    standalone: false
})
export class EscalationNavComponent implements OnInit {
  url: string;
  CallFunctionOnCloseModal: any;
  modalURL: string;
  MsgType: number;
  DisplayMessage: string;
  Data: any;
  EscalationForm: FormGroup;
  FormSearchNoticeCase: FormGroup;
  ModalHeading: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  Modules: any;
  ModuleSelected: any;
  CurrentModuleID: any;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.CallFunctionOnCloseModal = "RefreshPage";
    this.FormSearchNoticeCase = this.formBuilder.group({
      Modules: ['']
    });
    this.EscalationForm = this.formBuilder.group({
      Modules: ['']
    });
   
    //this.LoadEscalation();
    this.LoadModules();   
  }

  // LoadEscalation() {
  //   this.http.get(this.url + 'AlertNotificationDetail/LoadEscalationNav')
  //     .subscribe((data) => {
  //       if (data == null || data.toString() == "[]") {
  //         this.MsgType = 2; // No Data Found
  //         this.DisplayMessage = "No Data Found";
  //         this.Data = null;
  //       } else {
  //         this.MsgType = 0; // No Message
  //         this.Data = JSON.parse(data.toString());
  //       }
  //     },
  //       (error) => {
  //         this.MsgType = 3; // Error Message
  //         this.DisplayMessage = error.message;
  //       }
  //     );
  // }

  RefreshPage() {
    this.LoadEscalation(this.CurrentModuleID);
   // this.LoadNotification(this.CurrentModuleID);
    this.modalURL = '' ;
  }

  RemoveEmployee(ReportID, UserID) {
    this.alertService.showConfirm('Are you sure to remove this user from the list?').then((result) => {
      if (result) {
        this.http.get(this.url + 'AlertNotificationDetail/DeleteEscalation?ReportID=' + ReportID + '&UserID=' + UserID)
          .subscribe((data) => {
            this.alertService.showSuccess(data.toString());
            this.RefreshPage();
          }
          );
      }
    })
    // if (confirm('Are you sure to remove this user from the list?')) {
    //   this.http.get(this.url + 'AlertNotificationDetail/DeleteEscalation?ReportID=' + ReportID + '&UserID=' + UserID)
    //     .subscribe((data) => {
    //       this.alertService.success(data.toString(), this.options);
    //       this.RefreshPage();
    //     }
    //     );
    // }
  }
  OpenModal(url, ReportID, UserID) {
    this.ModalHeading = "Escalation Entry";
    this.modalURL =  url + "/" + ReportID + "/" + UserID;
  }

  OpenModalFeature(url) {
    this.ModalHeading = "Escalation Report Entry";
    this.modalURL =  url;
  }
  // Decision button
  LoadEscalation(ModuleID) {
   
    this.CurrentModuleID = ModuleID;
    this.http.get(this.url + 'AlertNotificationDetail/LoadEscalationNav?ModuleID=' + ModuleID)
      .subscribe((data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.Data = null;
        } else {
          this.MsgType = 0; // No Message
          this.Data = JSON.parse(data.toString());
        }
      },
        (error) => {
          this.MsgType = 3; // Error Message
          this.DisplayMessage = error.message;
        }
      );
  }
  LoadModules() {
    this.http.get(this.url + 'AlertNotificationDetail/Fetch_Notification_Header_Module?MainID=' + '')
      .subscribe((data) => {
        this.Modules = JSON.parse(data.toString());
        if (this.Modules.length > 0) {
          this.onModuleSelect(this.Modules[0].MainID);
          this.ModuleSelected = this.Modules[0].MainID;
        }
      }
      );
  }
  onModuleSelect(ModuleID) {
    this.LoadEscalation(ModuleID);
  }
// Decision button

}
